import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appUppercase]',
  standalone: false,
})
export class UppercaseDirective {
  constructor(
    private el: ElementRef,
    private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onEvent(event: any) {
    let uppercase;
    if (this.el.nativeElement.value) {
      uppercase = this.el.nativeElement.value.toUpperCase();
    } else {
      uppercase = this.el.nativeElement.value;
    }
    this.control.control.setValue(uppercase);
  }
}
